import { Tabs, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useQuery } from "@tanstack/react-query";
import { getInvoicesQueryOptions, getRejectedInvoicesQueryOptions } from "@/api/queryOptions/invoiceAPIQueryOptions";
import { SubmittedInvoiceTab } from "./submittedTab";
import { RejectedInvoiceTab } from "./rejectedTab";
import { DraftInvoiceTab } from "./draftTab";

const QUERY_LIMIT = 10;
export const InvoiceTab = () => {
    const auth = useAuth();
    const { t } = useTranslation(["claimsInvoicesOverview", "errorMessages"]);

    const { data: draftInvoices } = useQuery({
        ...getInvoicesQueryOptions({
            query: "",
            page: 0,
            limit: QUERY_LIMIT,
            sortDirection: "DESC",
            sortBy: "invoiceDate",
            includedStatuses: ["Draft"]
        }),
        enabled: auth.isAuthenticated
    });

    const { data: rejectedInvoices } = useQuery({
        ...getRejectedInvoicesQueryOptions({
            query: "",
            page: 0,
            limit: QUERY_LIMIT,
            sortDirection: "DESC",
            sortBy: "invoiceDate"
        }),
        enabled: auth.isAuthenticated
    });

    const draftCount = `(${draftInvoices?.totalResults ?? 0})`;
    const rejectedCount = `(${rejectedInvoices?.totalResults ?? 0})`;

    const tabs = [
        {
            label: t("claimsInvoicesOverview:submittedInvoicesTab.tabName"),
            component: <SubmittedInvoiceTab />,
            testId: "tabSubmittedInvoices",
            value: "submitted"
        },
        {
            label: `${t("claimsInvoicesOverview:draftInvoicesTab.tabName")} ${draftCount}`,
            component: <DraftInvoiceTab />,
            testId: "tabDraftInvoices",
            value: "draft"
        },
        {
            label: `${t("claimsInvoicesOverview:rejectedInvoicesTab.tabName")} ${rejectedCount}`,
            component: <RejectedInvoiceTab />,
            testId: "tabRejectedInvoices",
            value: "rejected"
        }
    ];

    return (
        <Flex w="100%">
            <Tabs.Root size="sm" defaultValue="submitted" width="100%">
                <Tabs.List id="invoiceNestedTablist">
                    {tabs.map(tab => (
                        <Tabs.Trigger key={tab.testId} value={tab.value} data-testid={tab.testId} fontSize="14px">
                            {tab.label}
                        </Tabs.Trigger>
                    ))}
                </Tabs.List>
                {tabs.map(tab => (
                    <Tabs.Content key={tab.testId} value={tab.value} pb="0">
                        {tab.component}
                    </Tabs.Content>
                ))}
            </Tabs.Root>
        </Flex>
    );
};
